import React from "react";
import {
  Box,
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
  Typography,
} from "@mui/material";
import {
  FirstPageIcon,
  LastPageIcon,
  NavigateBefore,
  NavigateNext,
} from "../../svg";
import { getNumberFormat } from "../../../utils/helper";
import { rowsPerPageOptions } from "../../../data/data";
import { useMemo } from "react";

const CustomPagination = ({
  page,
  totalPages,
  totalRows,
  rowsPerPage,
  handleChangePage,
  handleRowsPerPageChange,
  customPaginationStyle,
  pagesOptions = rowsPerPageOptions,
}) => {
  const handleChange = (event, value) => {
    handleChangePage(value - 1);
  };

  const findValue = useMemo(() => {
    return pagesOptions?.some((item) => item === rowsPerPage)
      ? rowsPerPage
      : "All";
  }, [pagesOptions, rowsPerPage]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: "10px",
        gap: 2,
        ...customPaginationStyle,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant="body2"
          sx={{
            mr: 2,
            fontSize: "var(--font-size-13)",
            color: "var(--primary-color)",
          }}
        >
          Rows per page:
        </Typography>
        <Select
          value={findValue}
          onChange={handleRowsPerPageChange}
          size="small"
          sx={{
            fontSize: "var(--font-size-13)",
            color: "var(--primary-color)",
            "& .MuiSelect-select": {
              paddingY: "3px",
            },
          }}
        >
          {pagesOptions.map((option) => {
            return (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            );
          })}
        </Select>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...customPaginationStyle,
        }}
      >
        <Pagination
          count={totalPages}
          page={page + 1}
          onChange={handleChange}
          size="small"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: FirstPageIcon,
                last: LastPageIcon,
                previous: NavigateBefore,
                next: NavigateNext,
              }}
              {...item}
              sx={{
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                minWidth: "20px",
                margin: "0 5px",
                // backgroundColor: "var(--iron-color)",
                "&.Mui-selected": {
                  color: "var(--primary-color)",
                  fontWeight: "var(--font-bold)",
                },
                fontSize: "var(--font-size-13)",
                fontWeight: "var(--font-regular)",
              }}
            />
          )}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: "var(--font-bold)",
            pr: "2px",
            fontVariantLigatures: "none",
          }}
        >
          No. of rows :
        </Typography>
        <span
          style={{
            fontSize: "13px",
            fontWeight: "var(--font-bold)",
            color: "var(--light-darker-gray)",
          }}
        >
          {" "}
          {getNumberFormat(totalRows)}{" "}
        </span>
      </Box>
    </Box>
  );
};

export default CustomPagination;
